import { useQuery } from '@tanstack/react-query';
import { listPendingReviews } from '@/api/core/sdk.gen';
import { useAuth } from '@/context/AuthContext';

export function useReviewCount() {
  const { token } = useAuth();

  const { data, isLoading } = useQuery({
    queryKey: ['reviews', 'count'],
    queryFn: async () => {
      const { data } = await listPendingReviews({ throwOnError: true });
      const items = data;
      return { count: Array.isArray(items) ? items.length : 0 };
    },
    enabled: !!token,
    refetchInterval: 60_000,
    retry: false,
  });

  return {
    count: data?.count ?? 0,
    isLoading,
  };
}
